const state = {
  user: [],
  authenticated: false
}

export default state
